/*
  Silph TCG — alignement exact des flèches du carrousel produits.

  Problème corrigé : Dawn déplace le carrousel de `step * sliderItemOffset`, où sliderItemOffset
  est calculé à partir de `offsetLeft` — donc arrondi au pixel entier. Or la largeur d'une carte
  vient d'un calc() en pourcentage, et vaut des pixels fractionnaires. Sur plusieurs pages, l'erreur
  s'accumule : la rangée finit décalée de quelques pixels et la carte de gauche apparaît coupée.

  Ici on ne calcule plus de distance : on vise la position RÉELLE de la carte cible
  (son offsetLeft). L'alignement est donc exact à chaque clic, quelle que soit la page.
*/
(function () {
  function init(slider) {
    var track = slider.querySelector('ul[id^="Slider-"]');
    var prev = slider.querySelector('button[name="previous"]');
    var next = slider.querySelector('button[name="next"]');
    if (!track || !prev || !next) return;
    if (slider.dataset.silphAligned === 'true') return;
    slider.dataset.silphAligned = 'true';

    // Remplacer les boutons par des clones retire les écouteurs posés par Dawn :
    // sans cela, les deux comportements de défilement se cumuleraient.
    var prevBtn = prev.cloneNode(true);
    var nextBtn = next.cloneNode(true);
    prev.parentNode.replaceChild(prevBtn, prev);
    next.parentNode.replaceChild(nextBtn, next);

    function items() {
      return Array.from(track.children).filter(function (el) {
        return el.clientWidth > 0;
      });
    }

    function step() {
      var s = parseInt(nextBtn.getAttribute('data-step'), 10);
      return s > 0 ? s : 1;
    }

    function perView(list) {
      if (list.length < 2) return 1;
      var offset = list[1].offsetLeft - list[0].offsetLeft;
      if (!offset) return 1;
      return Math.max(1, Math.round(track.clientWidth / offset));
    }

    function currentIndex(list) {
      if (!list.length) return 0;
      var target = track.scrollLeft + list[0].offsetLeft;
      var best = 0;
      var bestDist = Infinity;
      list.forEach(function (el, i) {
        var dist = Math.abs(el.offsetLeft - target);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function goTo(index) {
      var list = items();
      if (!list.length) return;
      var max = Math.max(0, list.length - perView(list));
      if (index < 0) index = 0;
      if (index > max) index = max;
      track.scrollTo({ left: list[index].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    }

    function refresh() {
      var list = items();
      if (!list.length) return;
      var max = Math.max(0, list.length - perView(list));
      var i = currentIndex(list);
      prevBtn.disabled = i <= 0;
      nextBtn.disabled = i >= max;
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(currentIndex(items()) - step());
    });
    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(currentIndex(items()) + step());
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(refresh, 120);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 200);
    });

    refresh();
  }

  function boot() {
    document.querySelectorAll('slider-component.silph-fc__slider').forEach(init);
  }

  function start() {
    // On attend que Dawn ait défini (et donc initialisé) slider-component, sinon il
    // rattacherait ses écouteurs sur nos clones.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slider-component').then(function () {
        requestAnimationFrame(boot);
      });
    } else {
      boot();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
